import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayToList',
})
export class StringArrayToHtmlListPipe implements PipeTransform {
  // remember to bind this to the [innerHtml]="myArray | arrayToList" as it outputs UL as html

  transform(value: string[]): string {
    return (
      '<ul>' +
      value
        .map((li) => {
          return `<li>${li}</li>`;
        })
        .join('') +
      '</ul>'
    );
  }
}
